import { render, staticRenderFns } from "./StateHistory.vue?vue&type=template&id=6023faec&scoped=true&lang=pug"
import script from "./StateHistory.vue?vue&type=script&lang=js"
export * from "./StateHistory.vue?vue&type=script&lang=js"
import style0 from "./StateHistory.vue?vue&type=style&index=0&id=6023faec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023faec",
  null
  
)

export default component.exports